exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".InviteUserDialog__form___2ZLJ2 {\n  display: flex;\n  flex-direction: column; }\n  .InviteUserDialog__form___2ZLJ2 .InviteUserDialog__row___2L3Ze {\n    display: inline-flex; }\n", ""]);

// exports
exports.locals = {
	"form": "InviteUserDialog__form___2ZLJ2",
	"row": "InviteUserDialog__row___2L3Ze"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules=true&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/sass-loader?includePaths[]=./src/styles!./src/components/Dialogs/InviteUserDialog/InviteUserDialog.scss
// module id = 728
// module chunks = 0